import css from './alertTile.module.css'
import { IAlert } from '@/services/alerts/alertTile.types'
import AlertBlock from '../AlertBlock'

interface IProps extends IAlert {
  onCancel: () => void
}

const AlertTile = (props: IProps) => {
  return (
    <div className={css.wrapper}>
      <AlertBlock {...props} />
    </div>
  )
}

export default AlertTile
